// extracted by mini-css-extract-plugin
export default {"essentials":"styles_essentials__CoAl6"};